/* eslint-disable no-undef,no-new,max-len,no-shadow */
(function iife(d) {
    // Get events with news from calendar
    const daysWithNews = d.querySelectorAll('.Calendar__day--hasevents .Calendar__day-content');

    daysWithNews.forEach((day) => {
        // Tooltip toggle-button
        const toggle = day.querySelector('.Calendar__tooltip-toggle');
        if (!toggle) return;
        // Tooltiplist of all Events
        const toolTip = day.querySelector('.ToolTip');
        if (!toolTip) return;
        // Arrow for floating ui, is and empty 0px div
        const arrowEl = day.querySelector('.ToolTip__arrow');
        if (!arrowEl) return;


        let cleanupAutoUpdate;

        /**
         * Show Tooltip unless its deactivated
         *
         * @param day one Day-Cell in Calendar
         */
        function showToolTip(day) {
            if (day.getAttribute('data-deactivated')) {
                return;
            }
            toolTip.removeAttribute('hidden');
            shared.updatePosition(day, toolTip, arrowEl);
            cleanupAutoUpdate = FloatingUIDOM.autoUpdate(day, toolTip, () => {
                shared.updatePosition(day, toolTip, arrowEl);
            });
        }

        /**
         * Hide Tooltip
         */
        function hideToolTip() {
            toolTip.setAttribute('hidden', 'true');
            if (cleanupAutoUpdate) cleanupAutoUpdate();
        }

        /**
         * Deactivate Tooltip on a day, so it won't open
         *
         * @param day one Day-Cell in Calendar
         */
        function deactivateToolTip(day) {
            day.setAttribute('data-deactivated', true);
        }

        /**
         * Reactivate Tooltip
         *
         * @param day one Day-Cell in Calendar
         */
        function activateToolTip(day) {
            day.removeAttribute('data-deactivated');
        }

        /**
         * Set aria-expand on Togglebutton
         *
         * @param exp State to be set
         */
        function toggleButton(exp) {
            toggle.setAttribute('aria-expanded', exp);
        }

        // Add event listeners
        // @see https://tollwerk.de/projekte/tipps-techniken-inklusiv-barrierefrei/titel-tooltips-toggletips#steuerung-mit-hover-und-focus

        if (toolTip && arrowEl) {

            toggle.addEventListener('click', () => {
                const exp = toggle.getAttribute('aria-expanded');
                if (exp === 'true') {
                    hideToolTip();
                    toggleButton('false');
                } else {
                    activateToolTip(day);
                    showToolTip(day);
                    toggleButton('true');
                }
            });

            // Mouse - Events
            day.addEventListener('mouseenter', () => {
                showToolTip(day);
            });

            day.addEventListener('mouseleave', () => {
                hideToolTip();
                toggleButton('false');
            });

            // Focus-Events
            day.addEventListener('focusin', () => {
                // showToolTip(day);
            });

            /**
             * If the focus leaves the entire day-cell-context, close Tooltip and if it has been deactivated, reactivate it
             */
            day.addEventListener('focusout', (e) => {
                if (!day.contains(e.relatedTarget)) {
                    hideToolTip();
                    activateToolTip(day);
                    toggleButton('false');
                }
            });

            // Keyboard-Events

            /**
             * If Escape is pressed while within day-cell, the Tooltip gets closed and cant
             * be reopened until the cell has lost focus
             */
            day.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    hideToolTip();
                    deactivateToolTip(day);
                    toggle.focus();
                    toggleButton('false');
                }
            });
        }
    });
}(document));
